// Keep independently editable comments beneath the mounted bundle video slider.
if (!customElements.get('elliosa-bp2-comments')) customElements.define('elliosa-bp2-comments', class extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const on = (type, callback) => document.addEventListener(type, callback, {signal:this.abort.signal});
    on('shopify:section:load', () => this.mount());
    on('shopify:section:unload', event => {
      if (this.content && event.target.contains(this.content)) this.stash();
    });
    on('shopify:section:select', event => {
      if (event.detail.sectionId === this.dataset.sectionId) this.content?.scrollIntoView({block:'center',behavior:'smooth'});
    });
    on('shopify:block:select', event => {
      if (event.detail.sectionId !== this.dataset.sectionId) return;
      [...(this.content?.querySelectorAll('[data-comment-id]') || [])].find(block => block.dataset.commentId === event.detail.blockId)?.scrollIntoView({block:'center',behavior:'smooth'});
    });
    if (document.readyState === 'loading') on('DOMContentLoaded', () => this.mount());
    else this.mount();
  }
  mount() {
    if (!this.isConnected) return;
    this.content ||= this.querySelector('[data-comments-template]')?.content.firstElementChild;
    if (!this.content) return;
    const bundle = document.querySelector('elliosa-bundle-product-2');
    const target = this.dataset.belowVideos === 'true' && bundle ? bundle.querySelector('[data-bp2-facebook-comments]') : this;
    if (!target) { this.stash(); return; }
    if (this.content.parentElement !== target) target.append(this.content);
  }
  stash() {
    if (this.content) this.querySelector('[data-comments-template]').content.append(this.content);
  }
  disconnectedCallback() { this.abort?.abort(); this.stash(); }
});
